import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "36",
  height: "36",
  viewBox: "0 0 36 36",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "18",
      cy: "18",
      r: "17",
      fill: "#161616",
      stroke: "white",
      "stroke-width": "2"
    }, null, -1),
    _createElementVNode("path", {
      d: "M13 13H23V25C23 25.5523 22.5523 26 22 26H14C13.4477 26 13 25.5523 13 25V13Z",
      stroke: "white",
      "stroke-width": "2"
    }, null, -1),
    _createElementVNode("rect", {
      x: "15",
      y: "8",
      width: "6",
      height: "2",
      fill: "white"
    }, null, -1),
    _createElementVNode("rect", {
      x: "9",
      y: "12",
      width: "18",
      height: "2",
      fill: "white"
    }, null, -1)
  ]))]))
}
export default { render: render }